import React, { Component } from 'react'

class PriceCardsArrowSvg extends Component {
  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="10"
        height="18"
        viewBox="0 0 10 18"
      >
        <path
          fill="#1C202C"
          fillRule="nonzero"
          d="M3.018 9l6.616 6.805a1.312 1.312 0 0 1 0 1.818 1.226 1.226 0 0 1-1.768 0L.366 9.91a1.312 1.312 0 0 1 0-1.818l7.5-7.714a1.226 1.226 0 0 1 1.768 0 1.312 1.312 0 0 1 0 1.818L3.018 9z"
        />
      </svg>
    )
  }
}

export default PriceCardsArrowSvg



// WEBPACK FOOTER //
// ./src/components/Icons/PriceCardsArrow/SvgFile.js